const Identify = () => import("@/views/agreement/Identify");
const Register = () => import("@/views/agreement/Register");
const Privacy = () => import("@/views/agreement/Privacy");
const Logoff = () => import("@/views/agreement/Logoff");
const Using = () => import("@/views/agreement/UsingTutorials");
const Usingen = () => import("@/views/agreement/UsingTutorials-en")
const Video = () => import("@/views/agreement/video")

const routes = [
    {
        path: "/agreement/identify",
        name: "identify",
        meta: {
            title: "实名认证协议"
        },
        component: Identify
    },
    {
        path: "/agreement/register",
        name: "register",
        meta: {
            title: "titles.useAgreement"
        },
        component: Register
    },
    {
        path: "/agreement/privacy",
        name: "privacy",
        meta: {
            title: "titles.privacy"
        },
        component: Privacy
    },
    {
        path: "/agreement/logoff",
        name: "logoff",
        meta: {
            title: "用户注销协议"
        },
        component: Logoff
    },
    {
        path: "/agreement/using",
        name: "using",
        meta: {
            title: "使用说明"
        },
        component: Using
    },
    {
        path: "/agreement/using-en",
        name: "using",
        meta: {
            title: "Instructions For Use"
        },
        component: Usingen
    },
    {
        path: "/agreement/video",
        name: "video",
        meta: {
            title: "闪光吉祥物应用视频"
        },
        component: Video
    },
];
export default routes;
